export default __webpack_public_path__ + "static/media/n5.6706356e.jpg";